import './FormRow.scss';

import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

export default class FormRow extends React.Component {
    static propTypes = {
        className: PropTypes.string,
        hasColumns: PropTypes.bool,
        columnCount: PropTypes.number
    };

    render() {
        return (
            <div className={classNames(
                'c-form-row',
                this.props.className,
                {
                    'has-columns': this.props.hasColumns === true,
                    'column-count--3': this.props.hasColumns === true && this.props.columnCount === 3,
                    'column-count--4': this.props.hasColumns === true && this.props.columnCount === 4
                })}>
                {this.props.children}
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/FormRow/index.js